import sanitizeHtml from "sanitize-html";
import { localInputToIso } from "helpers/date";
import { sanitizedConfig } from "helpers/utils";

export const PREVIEW_UPDATE_ID = "preview";

export function buildPreviewUpdate(form, uploadedImagePreview) {
	return {
		id: PREVIEW_UPDATE_ID,
		title: form.title.trim() || "Untitled release note",
		version: form.version.trim() || null,
		shortDescription: sanitizeHtml(form.shortDescription, sanitizedConfig),
		displayImageUrl: uploadedImagePreview || form.imageUrl.trim() || null,
		externalUrl: form.externalUrl.trim() || null,
		publishedAt:
			localInputToIso(form.publishedAtLocal) || new Date().toISOString(),
	};
}
